import { render, staticRenderFns } from "./MeetingDetails.vue?vue&type=template&id=6a934767"
import script from "./MeetingDetails.vue?vue&type=script&lang=js"
export * from "./MeetingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a934767')) {
      api.createRecord('6a934767', component.options)
    } else {
      api.reload('6a934767', component.options)
    }
    module.hot.accept("./MeetingDetails.vue?vue&type=template&id=6a934767", function () {
      api.rerender('6a934767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Meeting/MeetingDetails.vue"
export default component.exports